import { BasketDetailsModel, UpsellModel, UpsellTypes, DonationModel, BasketCareKitAddonModel, BasketValidationResultModel } from 'models/Basket';
import { BasketErrorModel } from 'models/Errors';
import {
    LoadBasketActionStart,
    LoadBasketActionSuccess,
    LoadBasketActionError,
    ClearBasketAction,
    LoadDonationActionStart,
    LoadDonationActionSuccess,
    LoadDonationActionError,
    UpdateBasketItemQuantityActionStart,
    UpdateBasketItemQuantityActionSuccess,
    UpdateBasketItemQuantityActionError,
    RemoveBasketItemActionStart,
    RemoveBasketItemActionSuccess,
    RemoveBasketItemActionError,
    RemoveSofaglideActionError,
    RemoveSofaglideActionStart,
    RemoveSofaglideActionSuccess,
    CalculateDeliveryCostActionStart,
    CalculateDeliveryCostActionSuccess,
    CalculateDeliveryCostActionError,
    RemoveCalculateDeliveryCostErrorAction,
    AddProductActionStart,
    AddProductActionSuccess,
    AddProductActionError,
    AddDonationActionStart,
    AddDonationActionSuccess,
    AddDonationActionError,
    AddUpsellActionStart,
    AddUpsellActionSuccess,
    AddUpsellActionError,
    SetDeliveryTypeActionStart,
    SetDeliveryTypeActionSuccess,
    SetDeliveryTypeActionError,
    RefreshAvailableUpsellsAction,
    RefreshAvailableUpsellsActionStart,
    RefreshAvailableUpsellsActionSuccess,
    RefreshAvailableUpsellsActionError,
    SaveLoadedCareKitsAction,
    AddProductAction,
    UpdateSofaglideActionError,
    UpdateSofaglideActionStart,
    UpdateSofaglideActionSuccess,
    UpdateSofaglideAction,
    UpdateSofashieldActionError,
    UpdateSofashieldActionStart,
    UpdateSofashieldActionSuccess,
    UpdateSofashieldAction,
    RemoveSofashieldAction,
    RemoveSofashieldActionError,
    RemoveSofashieldActionStart,
    RemoveSofashieldActionSuccess,
    RemoveAllSofashieldsActionError,
    RemoveAllSofashieldsActionStart,
    RemoveAllSofashieldsActionSuccess,
    InitBasketPageActionStart,
    InitBasketPageActionSuccess,
    InitBasketPageActionError,
    RemoveBasketAction,
    RemoveBasketActionStart,
    RemoveBasketActionSuccess,
    RemoveBasketActionError,
    SaveCurrentPageAction,
    SaveCurrentPageActionStart,
    SaveCurrentPageActionSuccess,
    SaveCurrentPageActionError,
    SetShowReservationWarningAction,
    ValidateBasketReservationsAction,
    ValidateBasketReservationsActionError,
    ValidateBasketReservationsActionStart,
    ValidateBasketReservationsActionSuccess,
    RemoveUserInfoAction,
    RemoveUserInfoActionStart,
    RemoveUserInfoActionSuccess,
    RemoveUserInfoActionError,
    SetShowSessionHasExpiredWarningAction,
    HandleApiAuthErrorRequestAction,
    HandleApiAuthErrorRequestActionStart,
    HandleApiAuthErrorRequestActionSuccess,
    HandleApiAuthErrorRequestActionError,
    CheckSofaglideForUpdateActionStart,
    CheckSofaglideForUpdateActionSuccess,
    CheckSofaglideForUpdateActionError,
    SetShowInvalidItemsRemovingWarningAction,
    ValidateCartAction,
    ValidateCartActionStart,
    ValidateCartActionSuccess,
    ValidateCartActionError,
    RemoveInvalidItemsAction,
    RemoveInvalidItemsActionStart,
    RemoveInvalidItemsActionSuccess,
    RemoveInvalidItemsActionError,
    RemoveAllInvalidItemsActionStart,
    RemoveAllInvalidItemsActionSuccess,
    RemoveAllInvalidItemsActionError,
    AddToCartFromUrlAction,
    AddToCartFromUrlActionStart,
    AddToCartFromUrlActionSuccess,
    AddToCartFromUrlActionError
} from './actions';

export enum LoadingItemTypes {
    ChangeQuantity = 'changeQuantity',
    ChangeSofaglideQuantity = 'changeSofaglideQuantity',
    ChangeSofashieldQuantity = 'changeSofashieldQuantity',
    RemoveItem = 'removeItem',
    RemoveSofaglide = 'removeSofaglide',
    RemoveSofashield = 'removeSofashield',
    RemoveAllSofashields = 'removeAllSofashields'
}

export interface BasketLoadingItem {
    id: string;
    loadingType: LoadingItemTypes;
}

export interface BasketState {
    isBasketLoading: boolean;
    isBasketPageInitializing: boolean;
    basket: BasketDetailsModel | null;
    basketLoadingItems: BasketLoadingItem[];
    basketLoadingUpsells: UpsellTypes[];
    donation: DonationModel | null;
    deliveryCostError: BasketErrorModel | null;
    isDonationLoading: boolean;
    isCalculatingDeliveryCost: boolean;
    waitsForChoosingDeliveryType: boolean;
    isUpsellsLoading: boolean;
    availableUpsells: UpsellModel[];
    loadedCareKits: BasketCareKitAddonModel[];
    shouldShowReservationWarning: boolean;
    shouldShowSessionHasExpiredWarning: boolean;
    shouldShowInvalidItemsRemovingWarning: boolean;
    isReservationValidationFinished: boolean;
    validationResult: BasketValidationResultModel;
    isValidatingCart: boolean;
    isAllInvalidItemsRemovingProcessing: boolean;
    isAddingToCartFromUrlProcessing: boolean;
}

export enum BasketActionTypes {
    LOAD_BASKET = 'basket/LOAD_BASKET',
    LOAD_BASKET_START = 'basket/LOAD_BASKET_START',
    LOAD_BASKET_SUCCESS = 'basket/LOAD_BASKET_SUCCESS',
    LOAD_BASKET_ERROR = 'basket/LOAD_BASKET_ERROR',

    INIT_BASKET_PAGE = 'basket/INIT_BASKET_PAGE',
    INIT_BASKET_PAGE_START = 'basket/INIT_BASKET_PAGE_START',
    INIT_BASKET_PAGE_SUCCESS = 'basket/INIT_BASKET_PAGE_SUCCESS',
    INIT_BASKET_PAGE_ERROR = 'basket/INIT_BASKET_PAGE_ERROR',

    CLEAR_BASKET = 'basket/CLEAR_BASKET',

    LOAD_DONATION = 'donations/LOAD_DONATION',
    LOAD_DONATION_START = 'donations/LOAD_DONATION_START',
    LOAD_DONATION_SUCCESS = 'donations/LOAD_DONATION_SUCCESS',
    LOAD_DONATION_ERROR = 'donations/LOAD_DONATION_ERROR',

    UPDATE_BASKET_ITEM_QUANTITY = 'basket/UPDATE_BASKET_ITEM_QUANTITY',
    UPDATE_BASKET_ITEM_QUANTITY_START = 'basket/UPDATE_BASKET_ITEM_QUANTITY_START',
    UPDATE_BASKET_ITEM_QUANTITY_SUCCESS = 'basket/UPDATE_BASKET_ITEM_QUANTITY_SUCCESS',
    UPDATE_BASKET_ITEM_QUANTITY_ERROR = 'basket/UPDATE_BASKET_ITEM_QUANTITY_ERROR',

    REMOVE_BASKET_ITEM = 'basket/REMOVE_BASKET_ITEM',
    REMOVE_BASKET_ITEM_START = 'basket/REMOVE_BASKET_ITEM_START',
    REMOVE_BASKET_ITEM_SUCCESS = 'basket/REMOVE_BASKET_ITEM_SUCCESS',
    REMOVE_BASKET_ITEM_ERROR = 'basket/REMOVE_BASKET_ITEM_ERROR',

    REMOVE_SOFAGLIDE = 'basket/REMOVE_SOFAGLIDE',
    REMOVE_SOFAGLIDE_START = 'basket/REMOVE_SOFAGLIDE_START',
    REMOVE_SOFAGLIDE_SUCCESS = 'basket/REMOVE_SOFAGLIDE_SUCCESS',
    REMOVE_SOFAGLIDE_ERROR = 'basket/REMOVE_SOFAGLIDE_ERROR',

    CHECK_SOFAGLIDE_FOR_UPDATE_START = 'basket/CHECK_SOFAGLIDE_FOR_UPDATE_START',
    CHECK_SOFAGLIDE_FOR_UPDATE_SUCCESS = 'basket/CHECK_SOFAGLIDE_FOR_UPDATE_SUCCESS',
    CHECK_SOFAGLIDE_FOR_UPDATE_ERROR = 'basket/CHECK_SOFAGLIDE_FOR_UPDATE_ERROR',

    UPDATE_SOFAGLIDE = 'basket/UPDATE_SOFAGLIDE',
    UPDATE_SOFAGLIDE_START = 'basket/UPDATE_SOFAGLIDE_START',
    UPDATE_SOFAGLIDE_SUCCESS = 'basket/UPDATE_SOFAGLIDE_SUCCESS',
    UPDATE_SOFAGLIDE_ERROR = 'basket/UPDATE_SOFAGLIDE_ERROR',

    REMOVE_SOFASHIELD = 'basket/REMOVE_SOFASHIELD',
    REMOVE_SOFASHIELD_START = 'basket/REMOVE_SOFASHIELD_START',
    REMOVE_SOFASHIELD_SUCCESS = 'basket/REMOVE_SOFASHIELD_SUCCESS',
    REMOVE_SOFASHIELD_ERROR = 'basket/REMOVE_SOFASHIELD_ERROR',

    UPDATE_SOFASHIELD = 'basket/UPDATE_SOFASHIELD',
    UPDATE_SOFASHIELD_START = 'basket/UPDATE_SOFASHIELD_START',
    UPDATE_SOFASHIELD_SUCCESS = 'basket/UPDATE_SOFASHIELD_SUCCESS',
    UPDATE_SOFASHIELD_ERROR = 'basket/UPDATE_SOFASHIELD_ERROR',

    CALCULATE_DELIVERY_COST = 'basket/CALCULATE_DELIVERY_COST',
    CALCULATE_DELIVERY_COST_START = 'basket/CALCULATE_DELIVERY_COST_START',
    CALCULATE_DELIVERY_COST_SUCCESS = 'basket/CALCULATE_DELIVERY_COST_SUCCESS',
    CALCULATE_DELIVERY_COST_ERROR = 'basket/CALCULATE_DELIVERY_COST_ERROR',

    REMOVE_ERROR_OF_CALCULATE_DELIVERY_COST = 'basket/REMOVE_ERROR_OF_CALCULATE_DELIVERY_COST',

    ADD_PRODUCT = 'basket/ADD_PRODUCT',
    ADD_PRODUCT_START = 'basket/ADD_PRODUCT_START',
    ADD_PRODUCT_SUCCESS = 'basket/ADD_PRODUCT_SUCCESS',
    ADD_PRODUCT_ERROR = 'basket/ADD_PRODUCT_ERROR',

    ADD_DONATION = 'basket/ADD_DONATION',
    ADD_DONATION_START = 'basket/ADD_DONATION_START',
    ADD_DONATION_SUCCESS = 'basket/ADD_DONATION_SUCCESS',
    ADD_DONATION_ERROR = 'basket/ADD_DONATION_ERROR',

    ADD_UPSELL = 'basket/ADD_UPSELL',
    ADD_UPSELL_START = 'basket/ADD_UPSELL_START',
    ADD_UPSELL_SUCCESS = 'basket/ADD_UPSELL_SUCCESS',
    ADD_UPSELL_ERROR = 'basket/ADD_UPSELL_ERROR',

    SET_DELIVERY_TYPE = 'basket/SET_DELIVERY_TYPE',
    SET_DELIVERY_TYPE_START = 'basket/SET_DELIVERY_TYPE_START',
    SET_DELIVERY_TYPE_SUCCESS = 'basket/SET_DELIVERY_TYPE_SUCCESS',
    SET_DELIVERY_TYPE_ERROR = 'basket/SET_DELIVERY_TYPE_ERROR',

    REFRESH_AVAILABLE_UPSELLS = 'basket/REFRESH_AVAILABLE_UPSELLS',
    REFRESH_AVAILABLE_UPSELLS_START = 'basket/REFRESH_AVAILABLE_UPSELLS_START',
    REFRESH_AVAILABLE_UPSELLS_SUCCESS = 'basket/REFRESH_AVAILABLE_UPSELLS_SUCCESS',
    REFRESH_AVAILABLE_UPSELLS_ERROR = 'basket/REFRESH_AVAILABLE_UPSELLS_ERROR',

    SAVE_LOADED_CARE_KITS = 'basket/SAVE_LOADED_CARE_KITS',

    REMOVE_BASKET = 'basket/REMOVE_BASKET',
    REMOVE_BASKET_START = 'basket/REMOVE_BASKET_START',
    REMOVE_BASKET_SUCCESS = 'basket/REMOVE_BASKET_SUCCESS',
    REMOVE_BASKET_ERROR = 'basket/REMOVE_BASKET_ERROR',

    REMOVE_USER_INFO = 'basket/REMOVE_USER_INFO',
    REMOVE_USER_INFO_START = 'basket/REMOVE_USER_INFO_START',
    REMOVE_USER_INFO_SUCCESS = 'basket/REMOVE_USER_INFO_SUCCESS',
    REMOVE_USER_INFO_ERROR = 'basket/REMOVE_USER_INFO_ERROR',

    SET_SHOW_SESSION_HAS_EXPIRED_WARNING = 'basket/SET_SHOW_SESSION_HAS_EXPIRED_WARNING',

    SAVE_CURRENT_PAGE = 'basket/SAVE_CURRENT_PAGE',
    SAVE_CURRENT_PAGE_START = 'basket/SAVE_CURRENT_PAGE_START',
    SAVE_CURRENT_PAGE_SUCCESS = 'basket/SAVE_CURRENT_PAGE_SUCCESS',
    SAVE_CURRENT_PAGE_ERROR = 'basket/SAVE_CURRENT_PAGE_ERROR',

    VALIDATE_BASKET_RESERVATIONS = 'basket/VALIDATE_BASKET_RESERVATIONS',
    VALIDATE_BASKET_RESERVATIONS_START = 'basket/VALIDATE_BASKET_RESERVATIONS_START',
    VALIDATE_BASKET_RESERVATIONS_SUCCESS = 'basket/VALIDATE_BASKET_RESERVATIONS_SUCCESS',
    VALIDATE_BASKET_RESERVATIONS_ERROR = 'basket/VALIDATE_BASKET_RESERVATIONS_ERROR',

    SET_SHOW_RESERVATION_WARNING = 'basket/SET_SHOW_RESERVATION_WARNING',

    HANDLE_API_AUTH_ERROR_REQUEST = 'basket/HANDLE_API_AUTH_ERROR_REQUEST',
    HANDLE_API_AUTH_ERROR_REQUEST_START = 'basket/HANDLE_API_AUTH_ERROR_REQUEST_START',
    HANDLE_API_AUTH_ERROR_REQUEST_SUCCESS = 'basket/HANDLE_API_AUTH_ERROR_REQUEST_SUCCESS',
    HANDLE_API_AUTH_ERROR_REQUEST_ERROR = 'basket/HANDLE_API_AUTH_ERROR_ERROR',

    SET_SHOW_INVALID_ITEMS_REMOVING_WARNING = 'basket/SET_SHOW_INVALID_ITEMS_REMOVING_WARNING',

    VALIDATE_CART = 'basket/VALIDATE_CART',
    VALIDATE_CART_START = 'basket/VALIDATE_CART_START',
    VALIDATE_CART_SUCCESS = 'basket/VALIDATE_CART_SUCCESS',
    VALIDATE_CART_ERROR = 'basket/VALIDATE_CART_ERROR',

    REMOVE_INVALID_ITEMS = 'basket/REMOVE_INVALID_ITEMS',
    REMOVE_INVALID_ITEMS_START = 'basket/REMOVE_INVALID_ITEMS_START',
    REMOVE_INVALID_ITEMS_SUCCESS = 'basket/REMOVE_INVALID_ITEMS_SUCCESS',
    REMOVE_INVALID_ITEMS_ERROR = 'basket/REMOVE_INVALID_ITEMS_ERROR',

    REMOVE_ALL_INVALID_ITEMS = 'basket/REMOVE_ALL_INVALID_ITEMS',
    REMOVE_ALL_INVALID_ITEMS_START = 'basket/REMOVE_ALL_INVALID_ITEMS_START',
    REMOVE_ALL_INVALID_ITEMS_SUCCESS = 'basket/REMOVE_ALL_INVALID_ITEMS_SUCCESS',
    REMOVE_ALL_INVALID_ITEMS_ERROR = 'basket/REMOVE_ALL_INVALID_ITEMS_ERROR',

    REMOVE_ALL_SOFASHIELDS = 'basket/REMOVE_ALL_SOFASHIELDS',
    REMOVE_ALL_SOFASHIELDS_START = 'basket/REMOVE_ALL_SOFASHIELDS_START',
    REMOVE_ALL_SOFASHIELDS_SUCCESS = 'basket/REMOVE_ALL_SOFASHIELDS_SUCCESS',
    REMOVE_ALL_SOFASHIELDS_ERROR = 'basket/REMOVE_ALL_SOFASHIELDS_ERROR',

    ADD_TO_CART_FROM_URL = 'ADD_TO_CART_FROM_URL',
    ADD_TO_CART_FROM_URL_START = 'ADD_TO_CART_FROM_URL_START',
    ADD_TO_CART_FROM_URL_SUCCESS = 'ADD_TO_CART_FROM_URL_SUCCESS',
    ADD_TO_CART_FROM_URL_ERROR = 'ADD_TO_CART_FROM_URL_ERROR'
}

export type BasketActions =
    LoadBasketActionStart
    | LoadBasketActionSuccess
    | LoadBasketActionError

    | InitBasketPageActionStart
    | InitBasketPageActionSuccess
    | InitBasketPageActionError

    | ClearBasketAction

    | LoadDonationActionStart
    | LoadDonationActionSuccess
    | LoadDonationActionError

    | UpdateBasketItemQuantityActionStart
    | UpdateBasketItemQuantityActionSuccess
    | UpdateBasketItemQuantityActionError

    | RemoveBasketItemActionStart
    | RemoveBasketItemActionSuccess
    | RemoveBasketItemActionError

    | RemoveSofaglideActionStart
    | RemoveSofaglideActionSuccess
    | RemoveSofaglideActionError

    | UpdateSofaglideAction
    | UpdateSofaglideActionStart
    | UpdateSofaglideActionSuccess
    | UpdateSofaglideActionError

    | CheckSofaglideForUpdateActionStart
    | CheckSofaglideForUpdateActionSuccess
    | CheckSofaglideForUpdateActionError

    | RemoveSofashieldAction
    | RemoveSofashieldActionStart
    | RemoveSofashieldActionSuccess
    | RemoveSofashieldActionError

    | UpdateSofashieldAction
    | UpdateSofashieldActionStart
    | UpdateSofashieldActionSuccess
    | UpdateSofashieldActionError

    | CalculateDeliveryCostActionStart
    | CalculateDeliveryCostActionSuccess
    | CalculateDeliveryCostActionError
    | RemoveCalculateDeliveryCostErrorAction

    | AddProductAction
    | AddProductActionStart
    | AddProductActionSuccess
    | AddProductActionError

    | AddDonationActionStart
    | AddDonationActionSuccess
    | AddDonationActionError

    | AddUpsellActionStart
    | AddUpsellActionSuccess
    | AddUpsellActionError

    | SetDeliveryTypeActionStart
    | SetDeliveryTypeActionSuccess
    | SetDeliveryTypeActionError

    | RefreshAvailableUpsellsAction
    | RefreshAvailableUpsellsActionStart
    | RefreshAvailableUpsellsActionSuccess
    | RefreshAvailableUpsellsActionError

    | SaveLoadedCareKitsAction

    | RemoveBasketAction
    | RemoveBasketActionStart
    | RemoveBasketActionSuccess
    | RemoveBasketActionError

    | RemoveUserInfoAction
    | RemoveUserInfoActionStart
    | RemoveUserInfoActionSuccess
    | RemoveUserInfoActionError

    | SetShowSessionHasExpiredWarningAction

    | SaveCurrentPageAction
    | SaveCurrentPageActionStart
    | SaveCurrentPageActionSuccess
    | SaveCurrentPageActionError

    | ValidateBasketReservationsAction
    | ValidateBasketReservationsActionStart
    | ValidateBasketReservationsActionSuccess
    | ValidateBasketReservationsActionError

    | SetShowReservationWarningAction

    | HandleApiAuthErrorRequestAction
    | HandleApiAuthErrorRequestActionStart
    | HandleApiAuthErrorRequestActionSuccess
    | HandleApiAuthErrorRequestActionError

    | SetShowInvalidItemsRemovingWarningAction

    | ValidateCartAction
    | ValidateCartActionStart
    | ValidateCartActionSuccess
    | ValidateCartActionError

    | RemoveInvalidItemsAction
    | RemoveInvalidItemsActionStart
    | RemoveInvalidItemsActionSuccess
    | RemoveInvalidItemsActionError

    | RemoveAllInvalidItemsActionStart
    | RemoveAllInvalidItemsActionSuccess
    | RemoveAllInvalidItemsActionError

    | RemoveAllSofashieldsActionStart
    | RemoveAllSofashieldsActionSuccess
    | RemoveAllSofashieldsActionError

    | AddToCartFromUrlAction
    | AddToCartFromUrlActionStart
    | AddToCartFromUrlActionSuccess
    | AddToCartFromUrlActionError;